import { hDeepCopy } from '@/utils/helpers';

// @vue/component
export default {
  name: 'DashboardSummaryForConnections',

  components: {
  },

  props: {
    connectionList: {
      type: Array,
      default: () => [],
    },
    connectionTypeList: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    copiedConnectionList() {
      return hDeepCopy(this.connectionList);
    },
    allConnectionsCount() {
      return this.copiedConnectionList.length;
    },
    callingCount() {
      return this.copiedConnectionList.filter(connection => connection._step === 'CALLING_SIMPLE_AGENT').length;
    },
    inQueueCount() {
      return this.copiedConnectionList.filter(connection => connection._step === 'MOH_PLAING').length;
    },
    massdialCount() {
      return this.copiedConnectionList.filter(connection => connection._massdial4call).length;
    },
    dialoutCount() {
      return this.copiedConnectionList.filter(connection => connection._dialout).length;
    },
    callwebCount() {
      return this.copiedConnectionList.filter(connection => connection._callweb).length;
    },
    ivrCount() {
      return this.copiedConnectionList.filter(
        connection => !connection._callweb
        && !connection._massdial4call
        && !connection._dialout,
      ).length;
    },
    massdialColor() {
      // eslint-disable-next-line camelcase
      if (this.connectionTypeList.massdial4call) return this.connectionTypeList.massdial4call[0]?.type_color;
      return '#787e84';
    },
    callwebColor() {
      // eslint-disable-next-line camelcase
      if (this.connectionTypeList.callweb) return this.connectionTypeList.callweb[0]?.type_color;
      return '#787e84';
    },
    dialoutColor() {
      // eslint-disable-next-line camelcase
      if (this.connectionTypeList.dialout) return this.connectionTypeList?.dialout[0]?.type_color;
      return '#787e84';
    },
    ivrColor() {
      // eslint-disable-next-line camelcase
      if (this.connectionTypeList.ivr) return this.connectionTypeList?.ivr[0]?.type_color;
      return '#787e84';
    },
  },
  methods: {
    getLighterColor(colorValue) {
      const color = require('color');
      return color(colorValue).lighten(0.5);
    },
    getDarkenColor(colorValue) {
      const color = require('color');
      return color(colorValue).darken(0.4);
    },
  },
};
